import React from "react"
import Link from "gatsby-link"
import logo from "../../assets/logo.svg"
import menu from "../../assets/menu.svg"
import close from "../../assets/close.svg"

var style = require("./header.module.css");

export default class Header extends React.Component {

  constructor(props) {
    super(props)
    this.handleClickMobileMenuOpen = this.handleClickMobileMenuOpen.bind(this);
    this.handleClickMobileMenuClose = this.handleClickMobileMenuClose.bind(this);
    this.handleClickMobileMenu = this.handleClickMobileMenu.bind(this);
    this.state = {
      mobileMenu: false,
    }
  }

  handleClickMobileMenuOpen(e) {
    e.preventDefault()
    this.setState({
      mobileMenu: true,
    })
  }

  handleClickMobileMenuClose(e) {
    e.preventDefault()
    this.setState({
      mobileMenu: false,
    })
  }

  handleClickMobileMenu(e) {
    this.setState({
      mobileMenu: false,
    })
  }

  render() {
    var menuClass = this.state.mobileMenu ? `${style.header} ${style.menuStateOpen}` : `${style.header}`;
    return (
      <div className={menuClass}>
        <div className={style.menu} onClick={this.handleClickMobileMenu}>
          <div className={style.linkGroup}>
            <Link className={style.link} to="/">Home</Link>
            <Link className={style.link} to="/boek/">Het boek</Link>
            <Link className={style.link} to="/artikelen/">Artikelen</Link>
          </div>
          <div className={style.logoContainer}>
            <Link className={style.logoa} to="/">
              <img className={style.logo} src={logo} width="361" />
            </Link>
          </div>
          <div className={style.linkGroup}>
            <Link className={style.link} to="/consultancy/">Consultancy</Link>
            <Link className={style.link} to="/over/">Over Robin</Link>
            <Link className={style.link} to="/contact/">Contact</Link>
          </div>
        </div>
        <div className={style.menuOpen} onClick={this.handleClickMobileMenuOpen}>
          <div className={style.menuBackgroundContainer}>
            <img className={style.menuBackground} src={menu} width="80" />
          </div>
        </div>
        <div className={style.menuClose} onClick={this.handleClickMobileMenuClose}>
          <div className={style.menuBackgroundContainer}>
            <img className={style.menuBackground} src={close} width="80" />
          </div>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/layouts/Header/Header.js